import { NgModule } from '@angular/core';
import { IfLDFeatureDirective } from './directives/if-ld-feature.directive';

/**
 * A transitory module to allow importing LD features without bringing in
 * the entire `SharedModule`.
 *
 * This module can be removed once `IfLDFeatureDirective` goes standalone.
 *
 * @deprecated - Use `IfLDFeatureDirective` directly instead or call the "isEnabledSignal" method
 * from the `LDFeatureManager` service to get a signal for the feature flag.
 */
@NgModule({
    imports: [IfLDFeatureDirective],
    exports: [IfLDFeatureDirective]
})
export class LDFeatureModule {}
